import React, { useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import '../../styles/signIn.scss';

const SetPassword = () => {
  const { setPassword } = useContext(AuthContext);
  const [formData, setFormData] = useState({ password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setError('');
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (formData.password !== formData.confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await setPassword(formData.password);
      // On success, recoveryMode clears and AuthGate renders the calendar.
    } catch (err) {
      setError('Could not set the password. The link may have expired — request a new invite or reset.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={handleSubmit}>
        <h1>Mangone Law Firm</h1>
        <h2>Set your password</h2>

        <div className="auth-input-container">
          <label htmlFor="password">New password</label>
          <input
            id="password"
            type="password"
            name="password"
            placeholder="New password"
            value={formData.password}
            onChange={handleChange}
            autoComplete="new-password"
            required
          />
        </div>

        <div className="auth-input-container">
          <label htmlFor="confirm">Confirm password</label>
          <input
            id="confirm"
            type="password"
            name="confirm"
            placeholder="Confirm password"
            value={formData.confirm}
            onChange={handleChange}
            autoComplete="new-password"
            required
          />
        </div>

        {error && <span className="auth-error">{error}</span>}

        <button className="auth-submit" type="submit" disabled={loading}>
          {loading ? 'Saving...' : 'Save password'}
        </button>
      </form>
    </div>
  );
};

export default SetPassword;
